import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { ELearningService } from '../../e-learning.service';

@Component({
  selector: 'app-modal-quiz',
  templateUrl: './modal-quiz.component.html',
  styleUrls: ['./modal-quiz.component.scss']
})
export class ModalQuizComponent implements OnInit {
  quizForm: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalQuizComponent>,
    private elearningService: ELearningService,
    private fb: FormBuilder
  ) {
    this.quizForm = this.fb.group({
      questions: this.fb.array([])
    })

    data.data[0].VALUE.forEach(question => {
      (this.quizForm.get('questions') as FormArray).push(
        this.fb.group({
          ANSWER: ['', Validators.required]
        })
      )
    });
  }

  ngOnInit(): void {
    // // console.log(this.data);
  }

  sendAnswer(a) {
    let answer = [];
    // // console.log(a);

    for (let i = 0; i < a.questions.length; i++) {
      answer.push({
        ID_TRANS: a.questions[i].ANSWER.ID_TRANS,
        ANSWER: a.questions[i].ANSWER.OPTION_NUMBER
      })
    }

    const body = {
      LESSON_ID: this.data.lessonId,
      COURSE_ID: this.data.courseId,
      QUIZ_ID: this.data.data[0].TOPIC_ID,
      VALUE: answer
    }

    // // console.log(body);


    this.elearningService.sendAnswer(body).subscribe(res => {
      // // console.log(res);

      const response = {
        status: true,
        value: res.result
      }
      this.dialogRef.close(response);
    }, err => {
      const response = {
        status: false,
        value: err.error.message
      }
      this.dialogRef.close(response);
    })
  }

  closeModal() {
    const response = {
      status: false,
      value: {}
    }

    this.dialogRef.close(response);
  }

  get option(): FormArray {
    return this.quizForm.get("option") as FormArray
  }
}
